import './lib/masonry';
import './lib/marquee';
import './lib/aos';
import './lib/tab';
import './lib/slick';
import './lib/fitty.min';

jQuery(document).ready(function ($) {
    // Handler for .ready() called.
    $("body").on('click', '[data-darkmode-toggle]', function () {
        $("#dark-mode-toggler").trigger("click");
    })

    $('body').on('click', '[data-toggle-klapper]', function() {
        $('[data-block-id="' + $(this).data("toggle-klapper") + '"]').addClass("is-active");
    })
});

jQuery(document).scroll(function() {
    if( jQuery(".pswp").length > 0 ) {
        jQuery(".pswp").css("top", jQuery(document).scrollTop())
    }
})

jQuery(document).ready(function ($) {
    // Handler for .ready() called.
    $("body").on('click', '[data-mobile-menu-toggle]', function () {
        $("body").toggleClass("show-mobile-menu");
    })
});


function interval() {
    while (true) {
        setInterval(showImage, 1);
    }
}

function showImage() {

    var x = clientX;
    var y = clientY;
    var image = document.getElementById("hoverimage");
    image.style.left = x;
    image.style.top = y;
}

let root = document.documentElement;

jQuery(document).ready(function () {

    var space_value = 0;
    if(jQuery(window).innerWidth() > 1600 ) {
        var space = jQuery(window).innerWidth() - jQuery(".site-footer__info").width();
        var space_half = space / 2;
        // console.log( space_value );
        space_value = space_half / 20;

        jQuery(".site-branding__left svg tspan").attr("x", -30 );
        jQuery(".site-branding__right svg tspan").attr("x", -30 );

    } else {
        space_value = 0;
        jQuery(".site-branding__left svg tspan").attr("x", -10 );
        jQuery(".site-branding__right svg tspan").attr("x", -10 );
    }

    root.style.setProperty('--branding-font-width', space_value);

    root.style.setProperty('--global--swiper-width', jQuery(".article-col-1").innerWidth() + "px");


});

jQuery(window).resize(function () {

    var space_value = 0;
    if(jQuery(window).innerWidth() > 1600 ) {
        var space = jQuery(window).innerWidth() - jQuery(".site-footer__info").width();
        var space_half = space / 2;
        space_value = space_half / 20;

        jQuery(".site-branding__left svg tspan").attr("x", -30 );
        jQuery(".site-branding__right svg tspan").attr("x", -30 );


    } else {
        space_value = 0;
        jQuery(".site-branding__left svg tspan").attr("x", -10 );
        jQuery(".site-branding__right svg tspan").attr("x", -10 );
    }

    root.style.setProperty('--branding-font-width', space_value);

});


var position = jQuery(window).scrollTop();

// should start at 0

jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    console.log( scroll );
    if (scroll > position) {
        jQuery('body').addClass('is-scrolled-down');
        jQuery('body').removeClass('is-scrolled-up');
    } else {
        jQuery('body').removeClass('is-scrolled-down');
        jQuery('body').addClass('is-scrolled-up');
    }

    if( scroll < 200 ) {
        jQuery('body').addClass('is-scrolled-up');
    }
    position = scroll;
});


// reference block

jQuery(document).ready(function($) {
    $('.hover-text').mousemove(function(e) {
        var $img = $("#" + $(this).data('image-id'))
        $img.stop(1, 1).addClass("show-block");
        $img.offset({
            top: e.pageY + 20,
            left: e.pageX + 10
        });
    }).mouseleave(function() {
        var $img = $("#" + $(this).data('image-id'))
        $img.removeClass("show-block");
    });
});